(() => {
const start=()=>{
const heading=document.querySelector('[data-design-heading]');
const search=document.querySelector('.toolbar>.search');
const slot=document.querySelector('.draft-header-search');
if(search&&slot)slot.append(search);
const update=()=>{
 if(!heading)return;
 const params=new URLSearchParams(location.search);
 const directory=params.get('browse');
 const section=document.querySelector('.record-custom-sections [aria-current="page"]');
 const selected=document.querySelector('.genres button.on');
 const value=directory==='artists'?'Artists':directory==='labels'?'Labels':section?section.textContent.trim().split(' / ').pop():selected?selected.textContent.trim():'Records';
 if(heading.textContent!==value)heading.textContent=value;
};

const allButton=document.querySelector('.genres [data-genre="All records"]');
const secondGroup=document.querySelector('.genres .record-genre-dropdown');
if(allButton&&secondGroup&&!document.querySelector('.record-all-dropdown')){
 const wrapper=document.createElement('div');wrapper.className='record-genre-dropdown record-all-dropdown';
 const menu=document.createElement('details');const summary=document.createElement('summary');summary.setAttribute('aria-label','All records categories');summary.textContent='All records categories';summary.tabIndex=-1;
 const submenu=document.createElement('div');submenu.className='record-genre-submenu';
 const second=secondGroup.querySelector('[data-genre="Second Hand"]');if(second)submenu.append(second);
 secondGroup.querySelectorAll('.record-genre-submenu [data-genre]').forEach(button=>submenu.append(button));
 allButton.replaceWith(wrapper);wrapper.append(allButton,menu);menu.append(summary,submenu);secondGroup.remove();
 menu.id='record-all-subcategories';allButton.setAttribute('aria-haspopup','true');allButton.setAttribute('aria-controls',menu.id);allButton.setAttribute('aria-expanded','false');
 menu.addEventListener('toggle',()=>allButton.setAttribute('aria-expanded',String(menu.open)));
 wrapper.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'||event.pointerType==='pen')menu.open=true;});
 allButton.addEventListener('click',event=>{if(event.detail===0||window.matchMedia('(hover: none)').matches)menu.open=!menu.open;});
 allButton.addEventListener('keydown',event=>{if(event.key==='ArrowDown'){event.preventDefault();menu.open=true;submenu.querySelector('button')?.focus();}});
 let dismissed=false;
 wrapper.addEventListener('pointerleave',event=>{if(event.pointerType==='mouse'||event.pointerType==='pen'){menu.open=false;dismissed=false;}});
 wrapper.addEventListener('focusout',event=>{if(!wrapper.contains(event.relatedTarget))menu.open=false;});
 wrapper.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();dismissed=true;menu.open=false;allButton.focus();}});

 submenu.addEventListener('click',event=>{if(event.target.closest('[data-genre]')){menu.open=false;dismissed=true;}});
 document.addEventListener('pointerdown',event=>{if(!wrapper.contains(event.target))menu.open=false;});
}

const genres=document.querySelector('.genres');
if(genres)new MutationObserver(update).observe(genres,{subtree:true,attributes:true,attributeFilter:['class','aria-pressed']});
const nav=document.querySelector('.record-catalogue-nav');
if(nav&&nav.parentElement)new MutationObserver(update).observe(nav.parentElement,{childList:true});
window.addEventListener('popstate',update);
document.addEventListener('click',()=>requestAnimationFrame(update));
update();
};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();